<template lang="pug">
  section
    b-container
      h2.mt-0.mb-5 {{ `GOOD ${makeMoment()}, ${account.user.firstname.toUpperCase()}` }}
      content-loader(:height="7", v-if="alert.loading")
      div(v-else-if="!profileComplete")
        b-card.highlight.mb-3.text-center.text-md-left
          .container
            h4 WE NEED SOME MORE INFO FROM YOU
            p We request a quick verification to confirm that you are you, this contributes towards a more secure platform for both our collectors and our artists.
            b-button.btn-outline.m-2(v-if="!isVerified", :to="{name: 'AccountProfile', query: { sendmeback: true, launch: 'accountVerify' }}") VERIFY ID
            b-button.btn-outline.m-2(v-if="!hasAddress", :to="{name: 'AccountAddress', query: { sendmeback: true }}") ADD ADDRESS
      div(v-else-if="artist.art_count < 1")
        b-card.highlight.mb-3.text-center.text-md-left
          .container
            h4 START ADDING ART
            p Your profile is ready, and you may now start uploading art to your gallery
            b-button.btn-outline.m-2(:to="{name: 'Art'}") GO TO GALLERY
      div(v-else="")
        p.mb-1.mt-3
          | LIVE ORDERS
          a.ml-2(@click="getOrders")
            font-awesome-icon.mr-2(icon="sync-alt")
          .row(v-if="orderLines.length > 0")
            .col-md-6.py-2(v-for="order in orderLines", :key="order.id")
              b-card.mb-3.highlight
                .container
                  .row.text-center
                    .col-md-6.text-md-left
                      h4.mt-0 {{ order.title }}
                      b-badge(variant="light") {{ order.type.toUpperCase() }}
                      small {{ order.created_pretty }}
                      br
                      br
                      b-form-checkbox(v-if="order.status === 'paid'", v-model='confirmAddress', switch)
                        span(href="") {{ `Confirm pickup at ${address.line_1}?` }}
                        br
                        router-link.text-primary(v-if="!confirmAddress", :to="{name: 'AccountAddress', query: { sendmeback: true }}") Update address
                      span(v-else="") {{ `Please have the item ready for pickup at ${address.line_1}` }}
                      span.d-block(v-if="order.status === 'paid'")
                    .col-md-6.text-md-right.pt-3
                      button-load.btnConfirmOrder(v-if="order.status === 'paid'", type="", :flag="order.busy", label="CONFIRM", classes="btn-outline", :disabled="!confirmAddress", @clicked="confirmOrderLine(order)")
                      span.spanOrderConfirmed.text-success(v-else-if="order.status === 'confirmed'")
                        font-awesome-icon.mr-2(icon="truck")
                        span Shipping
                      b-badge(variant="light", v-else="") {{ order.status.toUpperCase() }}
          nothing(v-else="")
        p.mb-1.mt-3 SALES & EARNINGS
        .row
          .col-12.col-md-6.py-2
            b-card
              .row
                .col-4.text-center
                  h3.m-1 {{ dashboardData.sales.sales  }}
                  span.text-muted SALES
                .col-4.text-center
                  h3.m-1 {{ dashboardData.sales.rentals  }}
                  span.text-muted RENTALS
                .col-4.text-center
                  h3.m-1 {{ dashboardData.sales.renewals  }}
                  span.text-muted RENEWALS
          .col-12.col-md-4.py-2
            b-card
              .row
                .col-6.text-center
                  h3.m-1 {{ formatRands(dashboardData.earnings.paid)  }}
                  span.text-muted RECEIVED
                .col-6.text-center
                  h3.m-1 {{ formatRands(dashboardData.earnings.pending)  }}
                  span.text-muted PENDING
        p.mb-1.mt-3 EXPOSURE
        .row
          .col-12.col-md-6.py-2
            b-card
              .row
                .col-4.text-center
                  h3.m-1 {{ dashboardData.analytics.showed }}
                  span.text-muted SEEN
                .col-4.text-center
                  h3.m-1 {{ dashboardData.analytics.viewed  }}
                  span.text-muted CLICKS
                .col-4.text-center
                  h3.m-1 {{ dashboardData.analytics.loved  }}
                  span.text-muted LOVE
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import { mapState } from 'vuex';
import { apiService, userService } from '@/services';
import standardMix from '@/mixins/standardMix';
import DoughnutChart from '@/components/charts/DoughnutChart';
import Vue from 'vue';

export default {
  name: 'ServiceDashboard',
  components: {
    ContentLoader,
    DoughnutChart,
  },
  mixins: [standardMix],
  data() {
    return {
      hasAddress: false,
      hasBankAccount: false,
      address: null,
      confirmAddress: false,
      isConnected: false,
      timestamp: '',
      dashboardData: null,
      orderLines: [],
      pendingOrderLines: [],
      shippingOrderLines: [],
      chartDoughnutData: {
        datasets: [
          {
            data: [],
            backgroundColor: ['#000000', '#ffffff'],
            // maxBarThickness: 50,
            // backgroundColor: '#007bff',
            // label: 'Income',
          },
        ],
        labels: [],
      },
      chartDoughnutOptions: {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 85,
        legend: {
          display: true,
          position: 'left',
          alignment: 'center',
        },
      },
    };
  },
  computed: {
    ...mapState('alert', ['alert']),
    profileComplete() {
      // return true;
      return (this.hasAddress && this.isVerified);
      // return (this.hasAddress && this.isVerified && this.hasBankAccount);
    },
  },
  methods: {
    makeMoment() {
      const today = new Date();
      const hour = today.getHours();
      let phase = '';
      if (hour < 12) phase = 'MORNING';
      else if (hour < 18) phase = 'AFTERNOON';
      else phase = 'EVENING';
      return phase;
    },
    async confirmOrderLine(orderLine) {
      const thisOrderline = orderLine;
      Vue.set(thisOrderline, 'busy', true);
      try {
        this.busy();
        await apiService.confirmOrderLine(this.profileId, orderLine.id);
        this.orderLines = await apiService.getOrderLines({ status: ['paid', 'confirmed'] });
        this.clear();
      } catch (error) {
        this.error(error.message || 'Could not confirm order');
      }
      thisOrderline.busy = false;
    },
    async getOrders() {
      this.orderLines = await apiService.getOrderLines({ status: ['paid', 'confirmed', 'shipping'] });
    },
  },
  async created() {
    try {
      this.loading();
      this.dashboardData = await apiService.getDashboard();
      this.getOrders();
      this.artist = await userService.getProfile(this.profileId);
      this.address = await userService.getAddress(this.profileId);
      this.hasAddress = this.artist.address_id !== null;
      this.hasBankAccount = this.artist.bank_account_id !== null;
      this.clear();
    } catch (error) {
      this.error('Could not load dashboard');
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Dashboard.vue